import { usePage } from "@inertiajs/vue3";
import { watch } from "vue";
import { toast } from "vue-sonner";

import type { SharedData } from "@/types";

export function useFlash() {
  const page = usePage<SharedData>();

  watch(
    () => ({
      notice: page.props.flash?.notice ?? null,
      alert: page.props.flash?.alert ?? null,
    }),
    (flash, previousFlash) => {
      if (flash.notice && flash.notice !== previousFlash?.notice) {
        toast(flash.notice);
      }

      if (flash.alert && flash.alert !== previousFlash?.alert) {
        toast.error(flash.alert);
      }
    },
    { immediate: true },
  );
}
